import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { ECollection } from "../enums/ECollection";
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TodayOffersService extends BaseService {
    constructor(public override http: HttpClient,
                public override utilsService: UtilsService,
                public override userService: UserService,
                public authService: AuthService) {
        super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.SW_TODAY_OFFERS}`);
    }

}
